export function gettime(t, t2) {

    let date = new Date(t);
    let arr = String(date).split(' ')
    let time
    let date2 = new Date(t2);
    let arr4 = String(date2).split(' ')
    let mth = getmth(arr[1])
    let mth2 = getmth(arr4[1])

    const englishTime = new Date(t).toLocaleString('en-US');
    const englishTime2 = new Date(t2).toLocaleString('en-US');
    let arr2 = String(englishTime).split(' ')
    let arr3 = String(englishTime2).split(' ')
    let arr5 = String(arr2[1]).split(':')
    let arr6 = String(arr3[1]).split(':')
    let diff = date2.getTime() - date.getTime()
    var leave1 = diff % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数  
    var hours = Math.floor(leave1 / (3600 * 1000));
    let days = Math.floor(diff / (24 * 3600 * 1000));
    console.log(arr[0].toUpperCase(), arr[0])

    if (t.slice(0, 4) == t2.slice(0, 4)) {
        if (t.slice(0, 7) == t2.slice(0, 7)) {
            if (t.slice(0, 10) == t2.slice(0, 10)) {
                time = arr[0].toUpperCase() + ' | ' + arr4[2] + ' ' + arr4[1] + ', ' + arr[3] + ' | ' + arr5[0] + ':' + arr5[1] + arr2[2] + ' - ' + arr6[0] + ':' + arr6[1] + arr3[2]
             
            } else {
                time = arr[0].toUpperCase() + ' | ' + arr[2] + ' - ' + arr4[2] + ' ' + arr4[1] + ', ' + arr[3] + ' | ' + arr5[0] + ':' + arr5[1] + arr2[2] + ' - ' + arr6[0] + ':' + arr6[1] + arr3[2]
             
            }
        } else {
            time = arr[0].toUpperCase() + ' | ' + arr[2] + ' ' + arr[1] + ' - ' + arr4[2] + ' ' + arr4[1] + ', ' + arr[3] + ' | ' + arr5[0] + ':' + arr5[1] + arr2[2] + ' - ' + arr6[0] + ':' + arr6[1] + arr3[2]
  
        }
    } else {
        time = arr[0].toUpperCase() + ' | ' + arr[2] + ' ' + arr[1] + ', ' + arr[3] + ' - ' + arr4[2] + ' ' + arr4[1] + ', ' + arr4[3] + ' | ' + arr5[0] + ':' + arr5[1] + arr2[2] + ' - ' + arr6[0] + ':' + arr6[1] + arr3[2]

    }

    // if (t.slice(0, 10) == t2.slice(0, 10)) {
    //     console.log(hours)
    //     if (days == 0 && hours >= 23) {
    //         time = arr[0].toUpperCase() + ' | ' + arr[2] + ' ' + arr[1] + ', ' + arr[3] + ' | ALL DAY'
    //     } else {
    //         time = arr[0].toUpperCase() + ' | ' + arr[2] + ' ' + arr[1] + ', ' + arr[3] + ' | ' + arr5[0] + ':' + arr5[1] + arr2[2] + ' - ' + arr6[0] + ':' + arr6[1] + arr3[2]
    //     }
    // } else {
    //     if (days == 0 && hours >= 23) {
    //         time = arr[0].toUpperCase() + ' | ' + arr[2] + ' ' + arr[1] + ' - ' + arr4[2] + ' ' + arr4[1] + ', ' + arr[3] + ' | ALL DAY'
    //     } else {
    //         time = arr[0].toUpperCase() + ' | ' + arr[2] + ' ' + arr[1] + ' - ' + arr4[2] + ' ' + arr4[1] + ', ' + arr[3] + ' | ' + arr5[0] + ':' + arr5[1] + arr2[2] + ' - ' + arr6[0] + ':' + arr6[1] + arr3[2]
    //     }
    // }
    return time
}


export function gettime2  (t, t2) {
    let date = new Date(t);
    let arr = String(date).split(' ')
    let time
    let date2 = new Date(t2);
    let arr4 = String(date2).split(' ')

    let mth = getmth(arr[1])
    let mth2 = getmth(arr4[1])

    const englishTime = new Date(t).toLocaleString('en-US');
    const englishTime2 = new Date(t2).toLocaleString('en-US');
    let arr2 = String(englishTime).split(' ')
    let arr3 = String(englishTime2).split(' ')
    let arr5 = String(arr2[1]).split(':')
    let arr6 = String(arr3[1]).split(':')
    let diff = date2.getTime() - date.getTime()
    var leave1 = diff % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数  
    var hours = Math.floor(leave1 / (3600 * 1000));
    let days = Math.floor(diff / (24 * 3600 * 1000));
    if (t.slice(0, 4) == t2.slice(0, 4)) {
        if (t.slice(0, 7) == t2.slice(0, 7)) {
            if (t.slice(0, 10) == t2.slice(0, 10)) {
                time = arr4[2] + ' ' + arr4[1] + ', ' + arr[3] + ' | ' + arr5[0] + ':' + arr5[1] + arr2[2] + ' - ' + arr6[0] + ':' + arr6[1] + arr3[2]
            } else {
                time = arr[2] + ' - ' + arr4[2] + ' ' + arr4[1] + ', ' + arr[3] + ' | ' + arr5[0] + ':' + arr5[1] + arr2[2] + ' - ' + arr6[0] + ':' + arr6[1] + arr3[2]
            }
        } else {
            time = arr[2] + ' ' + arr[1] + ' - ' + arr4[2] + ' ' + arr4[1] + ', ' + arr[3] + ' | ' + arr5[0] + ':' + arr5[1] + arr2[2] + ' - ' + arr6[0] + ':' + arr6[1] + arr3[2]
        }
    } else {
        time = arr[2] + ' ' + arr[1] + ', ' + arr[3] + ' - ' + arr4[2] + ' ' + arr4[1] + ', ' + arr4[3] + ' | ' + arr5[0] + ':' + arr5[1] + arr2[2] + ' - ' + arr6[0] + ':' + arr6[1] + arr3[2]
    }
    return time
}



export function gettime3  (t, t2) {
    let date = new Date(t);
    let arr = String(date).split(' ')
    let time
    let date2 = new Date(t2);
    let arr4 = String(date2).split(' ')

    let mth = getmth(arr[1])
    let mth2 = getmth(arr4[1])

    const englishTime = new Date(t).toLocaleString('en-US');
    const englishTime2 = new Date(t2).toLocaleString('en-US');
    let arr2 = String(englishTime).split(' ')
    let arr3 = String(englishTime2).split(' ')
    let arr5 = String(arr2[1]).split(':')
    let arr6 = String(arr3[1]).split(':')
    let diff = date2.getTime() - date.getTime()
    var leave1 = diff % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数  
    var hours = Math.floor(leave1 / (3600 * 1000));
    let days = Math.floor(diff / (24 * 3600 * 1000));
    if (t.slice(0, 4) == t2.slice(0, 4)) {
        if (t.slice(0, 7) == t2.slice(0, 7)) {
            if (t.slice(0, 10) == t2.slice(0, 10)) {
                time = arr4[2] + ' ' + mth2 
            } else {
                time = arr[2] + ' - ' + arr4[2] + ' ' + mth2 
            }
        } else {
            time = arr[2] + ' ' + mth+ ' - ' + arr4[2] + ' ' + mth2 
        }
    } else {
        time = arr[2] + ' ' + mth + ', ' + arr[3] + ' - ' + arr4[2] + ' ' + mth2 + ', ' + arr4[3]
    }
    return time
}

const getmth = (mth) => {
    if (mth == 'Jan') {
        mth = 'January'
    } else if (mth == 'Feb') {
        mth = 'February'
    } else if (mth == 'Mar') {
        mth = 'March'
    } else if (mth == 'Apr') {
        mth = 'April'
    } else if (mth == 'May') {
        mth = 'May'
    } else if (mth == 'Jun') {
        mth = 'June'
    } else if (mth == 'Jul') {
        mth = 'July'
    } else if (mth == 'Aug') {
        mth = 'August'
    } else if (mth == 'Sept') {
        mth = 'September'
    } else if (mth == 'Oct') {
        mth = 'October'
    } else if (mth == 'Nov') {
        mth = 'November'
    } else {
        mth = 'December'
    }
    return mth
}